import {useEffect} from "react";

export default function useEventEmitter(name, callback) {
    useEffect(() => {
        console.log("[useEventEmitter] Subscribing to event", name);
        document.addEventListener(name, callback);

        return () => {
            console.log("[useEventEmitter] Unsubscribing from event", name);
            document.removeEventListener(name, callback);
        }
    }, [name, callback]);
}
